import { useEffect, useState } from 'react';
import { Col, Row, Card, Badge } from 'react-bootstrap';
import { MdFavoriteBorder, MdFavorite } from 'react-icons/md';
import "./bookCard.css";
import { formatPrice } from '../../../../utils/utils';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
// import { deleteBook } from '../../bookUtils';
import { useAppStore } from "../../../../context/state";
import { handle_favorites } from '../../../../api/books';

import { getUser } from '../../../../utils/common';
// import { format } from 'date-fns'

import ProtectedAccess  from '../../../../components/ProtectedAccess'

/**
 * A short card for books to show book's cover, title, author, price, how to reference it
 * and wheter is in favourites or not. Aditionally, Contains one button to send the book
 * to the shopping cart.
 * @param {{book: json, author: json, userRole: string, lang: json}} props
 * @returns
 */
export default function BookCard(props) {

  const { lang, author, book, handleShow } =props;
  let user = getUser();
  let history = useNavigate();
  const [isFav, setIsFav] = useState(false);
  const addBook = useAppStore((state) => state.addBook)
  const books = useAppStore((state) => state.books)
  // const navigate = useNavigate();

  const truncate =(str)=>{
    return str.length > 800 ? `${str.substring(0, 800)} ...` : str;
  }

  useEffect(() => {
    /**
     * Handles isFav by seeing wheter the user has logged or not. If its logged,
     * the favorites is established as per user favorites list.
     * @returns 
     */
    const handleUserFav = () => {
      if (user == null) return;
      const uid = user.id || user._id
      setIsFav(book.favorites.includes(uid));
    }

    handleUserFav();
  }, [])

  const handleFavorite = async () => {

    if (!user) {
      let customId = 123;
      toast.warning(lang.user.error.not_logged_in, {
        toastId: customId,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false,
        onClose: () => {
          history('/editorial/user-access')
        }
      });
      return;
    }
    const user_id= user.id || user._id;

    const body = {
      user_id:user_id, 
      book_id: book._id,
      addToFav: !isFav
    };

    try {
      const response = await handle_favorites(body);
      const success_message = isFav ? lang.book.success.delete_favorite : lang.book.success.add_favorite;
      
      toast.success(success_message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false
      });

      if(!isFav){
        book.favorites.push(user_id)
      }else{
        const index = book.favorites.indexOf(user_id);
        book.favorites.splice(index, 1);
      }

      setIsFav(!isFav);
    } catch (error) {
      toast.error(lang.ERR_NETWORK);
    }
  }

  const showFav = () => {
    if (isFav) return (
      <MdFavorite onClick={handleFavorite} className='book-card-fav' />
    );

    return (
      <MdFavoriteBorder onClick={handleFavorite} className='book-card-fav' />
    )
  }

  const addBookToCart = () => {
    const existBook = books.find(el => el._id === book._id);
    if (existBook) {
      toast.info(lang.book.error.already_in_cart, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: false
      });
      return;
    }

    let bookToAdd = book;
    bookToAdd.qty = 1;
    addBook(bookToAdd);
    toast.success(lang.book.success.add_to_cart, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: true,
      pauseOnFocusLoss: false,
      closeOnClick: true,
      pauseOnHover: false
    });
  }
  
  const raiseOpenUrl=(url)=>{
      window.open(url, '_blank');
  }

  return (
    <div style={{
        display:'flex',
        flexDirection:'column'
    }}> 
      <Card className='header-author mt-2' style={{borderRadius:'0px'}}>
          <Row>
              <Col 
                  xs={{span: 12, order:0}} sm={{span: 12, order:0}} md={{span: 5, order:0}} xl={{span: 5, order:0}}
                  style={{
                      display:'flex',
                      alignItems:'center',
                      justifyContent:'center',
                      padding:'2px'
                  }}> 
                  <Card.Img src={book.coverImage || '/assets/app/cover.jpg' } alt={book.id} className="mx-auto d-block" 
                      style={{maxWidth:'220px',margin:'1.5rem',borderRadius:'10px',boxShadow:'2px 2px 10px #ccc'}}
                  />
              </Col>
              <Col xs={{span: 12, order:1}} sm={{span: 12, order:1}} md={{span: 7, order:1}} xl={{span: 7, order:1}}>
                  <Card.Body>
                      <h3>{book.title}</h3>
                      {/* <b>{book.subtitle.toUpperCase()}</b> */}
                      <p>
                        {' '}
                        <Link to={`/editorial/authors/${author.values?._id}`}>
                          {author.name}
                        </Link> <br/>
                      </p>

                      <div dangerouslySetInnerHTML={{__html: book.summary}} />

                      {/* <p className='pt-3'>
                        <span><b>Precio impreso tapa blanda: </b>{formatPrice(`${book.price1 || 0}`, lang.cart_coin)}<br/></span>
                        <span><b>Precio impreso tapa dura: </b>{formatPrice(`${book.price2 || 0}`, lang.cart_coin)}<br/></span>
                        <span><b>Precio impresión por demanda: </b>{formatPrice(`${book.price3 || 0}`, lang.cart_coin)}<br/></span>
                        <span><b>Precio Ed. digital: </b>{formatPrice(`${book.price}`, lang.cart_coin)}<br/></span>
                      </p> */}

                      <p>
                          {book.topic && <strong>Tema: </strong>} {book.topic}
                          {book?.topic?.length > 500 && ( <Link to={`/editorial/books/${books._id}`} 
                              className="text-primary" style={{cursor:'pointer', textDecoration:'underline'}} 
                              onClick={()=>console.log(books)}>
                              ver más
                          </Link>)}
                      </p>

                        <p>
                          {book.keywords.length >0 && 'Y algunas de sus palabras claves y etiquetas son:'} <br/><br/>
                          {book.keywords.map((tag, i)=>{
                              return (<span><Badge bg="secondary" key={i}>{ tag.label }</Badge>&nbsp;</span> );
                          })}
                        </p>                        
                        <Row>

                          <Col md={6}>
                            {book.openURL ? (
                              <button className='book-card-ebook-button w-100' onClick={()=>raiseOpenUrl(book.openURL)}>
                                  {lang.book.btndownload}
                                </button>
                            ) : (
                              // Si book.openURL está vacía, no se renderiza nada o puedes mostrar un mensaje
                              <p><b>Archivo no disponible</b></p>
                            )}


                          </Col>

                          {/*El de abajo es el código original para el botón de descarga*/}
                          {/* <Col md={6}>
                            {book.price === 0 ? (
                                <button className='book-card-ebook-button w-100' onClick={()=>raiseOpenUrl(book.openURL)}>
                                  {lang.book.btndownload}
                                </button>
                              ):(
                                <button className='book-card-ebook-button w-100' onClick={addBookToCart}>
                                  {lang.book.btnaddcart}
                                </button>
                              )
                            }
                          </Col>      */}                   

                          {/* <Col md={4}>
                            <button className='book-card-free-sample' onClick={()=>raiseOpenUrl(book.openURL)}>
                              {lang.book.free_sample}
                            </button>
                          </Col>

                          <Col xs={2} className='FixHover'>
                              {showFav()}
                              <span className='px-3'>{
                                book?.favorites?.length < 9? book?.favorites?.length:"10+"
                              }</span>
                          </Col>  */}                         
                        </Row>
                        {/* <ProtectedAccess 
                            element={
                                <button className="btn btn-sm btn-primary btn-block badge" type="button" onClick={()=>handleShow(author)} > Modificar</button>
                            }
                            role={['admin', 'editor']}
                          /> */}
                  </Card.Body>
              </Col>
          </Row>
      </Card>
    </div>
  )
}
